export const mexcAccountCategory = 'mexc'

export const networkEvmChainIds: Record<string, number | undefined> = {
  'Arbitrum One(ARB)': 42161,
  ASTAREVM: 592,
  'Avalanche C Chain(AVAX CCHAIN)': 43114,
  BASE: 8453,
  BERACHAIN: 80094,
  'BNB Smart Chain(BEP20)': 56,
  'Ethereum(ERC20)': 1,
  'Fantom(FTM)': 250,
  GLMR: 1284,
  Linea: 59144,
  MANTA: 169,
  'Mantle(MNT)': 5000,
  METIS: 1088,
  MOVR: 1285,
  OASYS: 248,
  'Optimism(OP)': 10,
  'Polygon(MATIC)': 137,
  'Polygon(MATIC-Bridged)': 137,
  RONIN: 2020,
  SCROLL: 534352,
  SONIC: 146,
  TAIKO: 167000,
  'zkSync Era': 324,
}

export const networkPolkadotChainIds: Record<string, number | undefined> = {
  ASTAR: 2006,
  POLKADOTASSETHUB: 1000,
  'Polkadot(DOT)': 0,
}

export const solanaNetwork = 'Solana(SOL)'
